export default __webpack_public_path__ + "static/media/PhosphorusHome.d0fe2d52.png";